var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"h-100",attrs:{"gutter":20}},[_c('el-col',{staticClass:"h-100",attrs:{"span":8}},[_c('search-container',{attrs:{"scrId":_vm.scrId}})],1),_c('el-col',{staticClass:"h-100",attrs:{"span":16}},[(_vm.show)?_c('main-container',{attrs:{"scrId":_vm.scrId}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }